module.exports = __webpack_public_path__ + "img/icon_promo.240d48e.webp";